import * as React from "react";
import classNames from "classnames";
import { Button } from "@grandvisionhq/common";
import { Text } from "@grandvisionhq/elements";
import { Form, Input } from "@grandvisionhq/forms";
import { Toggletip } from "@grandvisionhq/lib-visuals";
import { useIntl } from "@grandvisionhq/state";
/* empty css                           */
const LoyaltyPointsCardForm = ({
  savedCardNumber,
  validateCardNumber,
  onSubmit,
  onClear
}) => {
  const { getLabel } = useIntl();
  const labels = {
    actionLabel: getLabel("cart.loyalty.action.save"),
    inputPlaceHolder: getLabel("cart.loyalty.addCard.placeholder"),
    inputError: getLabel("cart.loyalty.invalidNumber"),
    cardNumber: getLabel("cart.loyalty.saved.number"),
    save: getLabel("common.actions.save"),
    enterNumber: getLabel("cart.loyalty.title"),
    clear: getLabel("common.actions.clear")
  };
  const [showError, setShowError] = React.useState(false);
  const [cardNumber, setCardNumber] = React.useState("");
  const isCardNumberValid = React.useCallback(
    (inputValue) => validateCardNumber(inputValue.trim()),
    [validateCardNumber]
  );
  const saveCard = React.useCallback(() => {
    const trimmedNumber = cardNumber.trim();
    if (isCardNumberValid(trimmedNumber)) {
      setShowError(false);
      onSubmit(trimmedNumber);
    } else {
      setShowError(true);
    }
  }, [cardNumber, isCardNumberValid, onSubmit]);
  const onInputChange = React.useCallback(
    (input) => {
      setCardNumber(input.value);
      if (isCardNumberValid(input.value)) {
        setShowError(false);
      }
    },
    [isCardNumberValid]
  );
  return /* @__PURE__ */ React.createElement("div", { className: "loyalty-card-form" }, savedCardNumber ? /* @__PURE__ */ React.createElement("div", { className: "loyalty-card-form__clear-container" }, /* @__PURE__ */ React.createElement(Text, { className: "loyalty-card-form__clear-text" }, labels.cardNumber, ": ", savedCardNumber), /* @__PURE__ */ React.createElement(
    Button,
    {
      onClick: onClear,
      caption: labels.clear,
      variant: "outline",
      className: "loyalty-card-form__clear-button"
    }
  )) : /* @__PURE__ */ React.createElement(Form, { name: "loyalty-card-form", className: "loyalty-card-form__add-container" }, /* @__PURE__ */ React.createElement("div", { className: "loyalty-card-form__enter-label" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "loyalty-card-input", className: "loyalty-card-form__enter-text" }, labels.enterNumber), /* @__PURE__ */ React.createElement(
    Toggletip,
    {
      message: getLabel("cart.loyalty.loyaltyNumberInfo"),
      className: "loyalty-card-form__tooltip"
    }
  )), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "loyalty-card-input",
      className: classNames("loyalty-card-form__card-input", "form-control__input"),
      type: "text",
      initialValue: cardNumber,
      placeholder: labels.inputPlaceHolder,
      "aria-label": labels.enterNumber,
      onChange: onInputChange
    }
  ), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    Button,
    {
      className: "loyalty-card-form__save-button",
      onClick: saveCard,
      caption: labels.save,
      type: "submit",
      variant: "solid",
      size: "medium"
    }
  )), cardNumber && showError && /* @__PURE__ */ React.createElement(Text, { className: "loyalty-card-form__error", variant: "caption" }, labels.inputError)));
};
export {
  LoyaltyPointsCardForm
};
//# sourceMappingURL=LoyaltyPointsCardForm.js.map
